/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AiOccupationCategorizationCapabilityApiModel } from './aiOccupationCategorizationCapabilityApiModel';


export interface AiOccupationCategorizationOccupationApiModel { 
    occupationId: number;
    occupationName: string;
    capabilityIds: Array<number>;
    capabilities: Array<AiOccupationCategorizationCapabilityApiModel>;
    needsReview: boolean;
    explanation?: string | null;
}

